import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"plus\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 8H4s-.5 0-.5.5.5.5.5.5h4v4s0 .5.5.5.5-.5.5-.5V9h4s.5 0 .5-.5S13 8 13 8H9V4s0-.5-.5-.5S8 4 8 4v4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol